import { Inject } from 'inversify-props'
import { AtributosDaVariante, ConsultaPrecoDeProduto, FormProdutoSimples, Page, Produto, ProdutoProjection, SituacaoDoProdutoNaLoja, Variante } from '@/models'
import type { EstoqueServiceAdapter, ProdutoServiceAdapter } from '..'
import { AxiosRequestConfig } from 'axios'

export class FindProdutoUseCase {
	@Inject('ProdutoServiceAdapter')
	private produtoService!: ProdutoServiceAdapter

	@Inject('EstoqueServiceAdapter')
	private depositoService!: EstoqueServiceAdapter

	findProdutoById = async (id: string): Promise<Produto> =>
		await this.produtoService.get(id)

	find = async (params?: any, config?: AxiosRequestConfig) => {
		return await this.produtoService.find(params, config)
	}

	findProdutosSeletor = async (params?: any, config?: AxiosRequestConfig) => {
		return await this.produtoService.findProdutosSeletor(params, config)
	}

	findOtimizado = async (params?: any, config?: AxiosRequestConfig) => {
		return await this.produtoService.findOtimizado(params, config)
	}

	async findProdutoComEstoque(identificador: string, loja: string): Promise<Produto> {
		return this.depositoService.encontrarProdutoComEstoque(identificador, loja)
	}

	async validarProduto(identificador: string, loja: string, quantidade: number, validar?: boolean): Promise<Produto> {
		return this.depositoService.validarProduto(identificador, loja, quantidade, validar)
	}

	async validarProdutoDesativado(produtoId: string): Promise<Produto> {
		return this.produtoService.validarProdutoDesativado(produtoId)
	}

	async findProdutoComEstoqueRomaneio(identificador: string, loja: string, quantidade: number, tipoDeMovimentacao: string): Promise<Produto> {
		return this.depositoService.encontrarProdutoComEstoqueRomaneio(identificador, loja, quantidade, tipoDeMovimentacao)
	}

	async findProdutoPorIdentificador(identificador: string): Promise<Produto> {
		return this.produtoService.encontrarProdutoPorIdentificador(identificador)
	}

	buscaItensPorTabelaDePreco = async (idDaTabelaDePreco: string, params?: any, config?: AxiosRequestConfig): Promise<Page<Produto>> =>
		await this.produtoService.buscaItensSemPrecoNaTabela(idDaTabelaDePreco, params, config)

	buscaSituacaoDosProdutos = async (idLoja: string, params?: any, config?: AxiosRequestConfig): Promise<Page<SituacaoDoProdutoNaLoja>> =>
		await this.produtoService.buscaSituacaoDosProdutos(idLoja, params, config)

	buscarVariantePorAtributos = async (produtoPaiId: string, atributos: AtributosDaVariante[]): Promise<Variante> =>
		await this.produtoService.buscarVariantePorAtributos(produtoPaiId, atributos)

	findConsultaPrecoDeProduto = async (produtoId: string, lojaId: string): Promise<ConsultaPrecoDeProduto[]> =>
		await this.produtoService.findConsultaPrecoDeProduto(produtoId, lojaId)

	findConsultaEstoqueDeProduto = async (produtoId: string, lojaId: string): Promise<Record<string, any>[]> =>
		await this.produtoService.findConsultaEstoqueDeProduto(produtoId, lojaId)

	async validaEstoqueNegativando(identificadores: string[], loja: string, quantidades: number[]): Promise<Produto> {
		return this.depositoService.validaEstoqueNegativando(identificadores, loja, quantidades)
	}

	async findProdutosComplementaresByIds(params?: any, config?: AxiosRequestConfig): Promise<ProdutoProjection[]> {
		return await this.produtoService.findProdutosComplementaresByIds(params, config)
	}

	async findProdutosSimilaresByIds(params?: any, config?: AxiosRequestConfig): Promise<FormProdutoSimples[]> {
		return await this.produtoService.findProdutosSimilaresByIds(params, config)
	}

	buscarVariantes = async (produtoPaiId: string): Promise<Variante[]> =>
		await this.produtoService.buscarVariantes(produtoPaiId)

	async findProdutoByCsv(csv: File, isProdutoPai: boolean, possuiCabecalho: boolean): Promise<void> {
		return await this.produtoService.findProdutoByCsv(csv, isProdutoPai, possuiCabecalho)
	}
	validarSkusJaExistentes = async (params?: any, config?: AxiosRequestConfig): Promise<string[]> =>
		await this.produtoService.validarSkusJaExistentes(params, config)

	findProdutosRfidParaOCaixa = async (pdvId: string, config?: AxiosRequestConfig): Promise<Produto[]> =>
		await this.produtoService.findProdutosRfidParaOCaixa(pdvId, config)

	finalizarProcessoRfidCaixa = async (pdvId: string): Promise<void> =>
		await this.produtoService.finalizarProcessoRfidCaixa(pdvId)

	finalizarProcessoRfidNota = async (chave: string): Promise<void> =>
		await this.produtoService.finalizarProcessoRfidNota(chave)

	updateStatusRfid = async (pdvId: string): Promise<void> =>
		await this.produtoService.updateStatusRfid(pdvId)
}
